/**
 * Address utilities for workorder components
 */

import { Workorder } from '@certhon/models';

/**
 * Check if workorder has a valid address for route calculation.
 * A valid address is a non-empty, non-whitespace string.
 */
export function hasValidAddress(workorder: Workorder): boolean {
  return !!(workorder.location_address && workorder.location_address.trim());
}
